<h2 mat-dialog-title>Envío a SOFLEX</h2>

<mat-dialog-content class="mat-typography">
  @if (loading) {
    <mat-progress-bar mode="indeterminate" />
  } @else if (error) {
    <p class="error">{{ error }}</p>
  } @else if (log) {
    <!-- Resumen -->
    <div class="resumen">
      <div><b>Cliente:</b> {{ data.clienteNombre || log.idCliente }}</div>
      <div>
        <b>Operación:</b> {{ log.tipoOperacion }} (<span class="mono">{{
          log.metodoAPI
        }}</span
        >)
      </div>
      <div>
        <b>Estado:</b>
        <span class="estado" [ngClass]="log.estado">{{ log.estado }}</span>
      </div>
      <div><b>HTTP:</b> {{ log.responseStatus ?? "-" }}</div>
      <div><b>Intentos:</b> {{ log.intentos }}</div>
      <div>
        <b>Duración:</b>
        {{ log.duracionMs != null ? log.duracionMs + " ms" : "-" }}
      </div>
      <div>
        <b>Creado:</b> {{ log.fechaCreacion | date: "dd/MM/yyyy HH:mm:ss" }}
      </div>
      <div>
        <b>Último intento:</b>
        {{ log.fechaUltimoIntento | date: "dd/MM/yyyy HH:mm:ss" }}
      </div>
      <div>
        <b>Éxito:</b> {{ log.fechaExito | date: "dd/MM/yyyy HH:mm:ss" }}
      </div>
      <div>
        <b>Tracking ID:</b>
        <span class="mono">{{ log.requestBody?.trackingid }}</span>
      </div>
      <div>
        <b>Config vecino:</b>
        <span class="mono">{{ log.idConfigVecino }}</span>
      </div>
      @if (log.idAlerta) {
        <div>
          <b>Alerta:</b> <span class="mono">{{ log.idAlerta }}</span>
        </div>
      }
      <div>
        <b>Log:</b> <span class="mono">{{ log._id }}</span>
      </div>
    </div>

    @if (log.mensajeError) {
      <div class="error"><b>Error:</b> {{ log.mensajeError }}</div>
    }

    <mat-tab-group animationDuration="0ms">
      <!-- Request -->
      <mat-tab label="Request">
        <div class="seccion">
          <div class="linea mono">
            <b>{{ log.requestMetodo || "POST" }}</b> {{ log.requestUrl || "-" }}
          </div>
          <div>
            <b>Host:</b> <span class="mono">{{ host || "-" }}</span>
          </div>

          <h3>Headers</h3>
          @if (headers(log.requestHeaders).length) {
            <table class="headers">
              @for (h of headers(log.requestHeaders); track h.key) {
                <tr>
                  <td class="mono key">{{ h.key }}</td>
                  <td class="mono">{{ h.value }}</td>
                </tr>
              }
            </table>
          } @else {
            <p class="vacio">Sin headers registrados</p>
          }

          <h3>
            Body HTTP
            <button
              mat-icon-button
              matTooltip="Copiar"
              (click)="copiar(log.requestBodyHttp)"
            >
              <mat-icon>content_copy</mat-icon>
            </button>
          </h3>
          @if (log.requestBodyHttp) {
            <pre class="json">{{ log.requestBodyHttp | json }}</pre>
          } @else {
            <p class="vacio">
              Sin body HTTP registrado (logs anteriores a la captura cruda).
            </p>
          }
        </div>
      </mat-tab>

      <!-- Response -->
      <mat-tab label="Respuesta">
        <div class="seccion">
          <div><b>Status:</b> {{ log.responseStatus ?? "-" }}</div>

          <h3>Headers</h3>
          @if (headers(log.responseHeaders).length) {
            <table class="headers">
              @for (h of headers(log.responseHeaders); track h.key) {
                <tr>
                  <td class="mono key">{{ h.key }}</td>
                  <td class="mono">{{ h.value }}</td>
                </tr>
              }
            </table>
          } @else {
            <p class="vacio">Sin headers registrados</p>
          }

          <h3>
            Body
            <button
              mat-icon-button
              matTooltip="Copiar"
              (click)="copiar(log.responseBody)"
            >
              <mat-icon>content_copy</mat-icon>
            </button>
          </h3>
          @if (log.responseBody != null) {
            <pre class="json">{{ log.responseBody | json }}</pre>
          } @else {
            <p class="vacio">Sin respuesta</p>
          }
        </div>
      </mat-tab>

      <!-- DTO interno -->
      <mat-tab label="Datos de origen">
        <div class="seccion">
          <p class="vacio">
            Datos internos con los que se armó el envío (no es el body HTTP).
          </p>
          <h3>
            requestBody
            <button
              mat-icon-button
              matTooltip="Copiar"
              (click)="copiar(log.requestBody)"
            >
              <mat-icon>content_copy</mat-icon>
            </button>
          </h3>
          <pre class="json">{{ log.requestBody | json }}</pre>
        </div>
      </mat-tab>

      @if (log.stackTrace) {
        <mat-tab label="Stack trace">
          <div class="seccion">
            <pre class="json">{{ log.stackTrace }}</pre>
          </div>
        </mat-tab>
      }
    </mat-tab-group>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" mat-dialog-close>Cerrar</button>
</mat-dialog-actions>
